<template>
  <div class="chips-container">
    <div class="content">
      <v-chip-group v-model="selectedItem" column>
        <v-chip class="ma-2" active-class="active-chip" v-for="(chip, i) in chips" :key="i">
          {{ chip.text }}
        </v-chip>
      </v-chip-group>
      <!-- COMMENT OUT TEXTFIELD
      <v-text-field
        placeholder="Placeholder text..."
        v-model="chipsInput"
        outlined
        solo
        flat
        block
        class="input"
      ></v-text-field>
      !-->
      <div class="additional-topic"><a @click="reportAdditionalTopic()">Ihnen fehlt ein Thema?</a></div>
    </div>
    <v-btn :disabled="selectedItem === undefined" depressed class="primary-txt-btn" @click="submitAnswer()">{{
      buttons.submit.text
    }}</v-btn>
  </div>
</template>
<script>
export default {
  name: "ChipsCard",
  data() {
    return {
      selectedItem: undefined, // was [] with multi selection
      chipsInput: "",
      chips: [
        {
          text: "Demenz",
          disabled: true,
          popupText: "ONLY WHEN DISABLED pop up text lorem ipsum ",
          inputInterpretationContext: {
            variableName: "dementia",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Inkontinenz",
          disabled: true,
          popupText: "ONLY WHEN DISABLED pop up text lorem ipsum ",
          inputInterpretationContext: {
            variableName: "incontinence",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Körperpflege",
          inputInterpretationContext: {
            variableName: "bodycare",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Mobilität",
          inputInterpretationContext: {
            variableName: "mobility",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Dekubitus",
          inputInterpretationContext: {
            variableName: "decubitus",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Alltagshilfen",
          inputInterpretationContext: {
            variableName: "everydaygoods",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Fitness",
          inputInterpretationContext: {
            variableName: "fitness",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "Sturzgefahr",
          inputInterpretationContext: {
            variableName: "fallrisks",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
      ],
      buttons: {
        submit: "Weiter zur nächsten Frage",
      },
    }
  },
  methods: {
    submitAnswer() {
      let newInput = {
        chips: {},
      }
      
      // temporary single choice fix
      newInput.chips[this.chips[this.selectedItem]["inputInterpretationContexts"][0]["variableName"]] = true;

      /*
      former multiple choice code

      for (let chipIndex of this.selectedItem) {
        // check if single or multiple inputInterpretationContext

        if ("inputInterpretationContext" in this.chips[chipIndex]) {
          // create key for every chip in newInput.chips and set bool to true
          newInput.chips[this.chips[chipIndex]["inputInterpretationContext"]["variableName"]] = true
        }
        // TODO => REFACTOR multiple inputInterpretationContexts across all GUI Templates
        // only buttonToBoolTrue and checkboxToArray working atm
        else if ("inputInterpretationContexts" in this.chips[chipIndex]) {
          this.chips[chipIndex]["inputInterpretationContexts"].forEach(function (singleIntContext) {
            newInput.chips[singleIntContext["variableName"]] = true
          })
        } else {
          console.warn("inputInterpretationContext/s does not match expected format!")
        }
      }
      */

      this.$emit("submitAnswer", newInput)
    },
    reportAdditionalTopic() {
      this.$emit("reportNewTopicModal")
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Chips Card")
      this.buttons.submit = executableSystemAction.guiTemplateContent.buttons.submit
      this.chips = executableSystemAction.guiTemplateContent.chips
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
  watch: {
    selectedItem: {
      handler(newValue) {
        // temporary single choice code
        console.log(newValue)

        if (this.chips[this.selectedItem]["disabled"] === true){
          let topicToReport = this.chips[this.selectedItem]["text"];
          this.$emit("showFeatureUnavailableModal", topicToReport)
          this.selectedItem = undefined;
        }

        /*
        FORMER MULTI SELECT CODE
        // check if newest added chip is disabled
        if (newValue.length > 0 && this.chips[newValue.at(-1)].disabled === true) {
          let topicToReport = this.chips[newValue.at(-1)].text;

          // remove chip from v-model and show not avaiable
          let idx = this.selectedItem.indexOf(newValue.at(-1))
          this.selectedItem.splice(idx, 1)
          this.selectedItem = [...this.selectedItem]
          this.$emit("showFeatureUnavailableModal", topicToReport)
        }
        */
      },
    },
  },
}
</script>

<style></style>
